<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="90%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input v-model.trim="form.title" class="fix-width" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="内容" prop="text">
          <tinymce-editor :height="900" :value="form.text" @inputChange="inputChange"></tinymce-editor>
        </el-form-item>
        <el-form-item label="按钮列表">
          <el-button type="primary" size="mini" class="mb-10" @click="addBtn(null)">
            增加
          </el-button>
          <el-table stripe :data="form.buttonList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="按钮图片"
              prop="title"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <img :src="row.image[0]&&row.image[0].url" style="height:64px;width:128px" />
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="跳转页面"
              prop="url"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="80px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="btnDelete($index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="btnFormVisible"
      :close-on-click-modal="false"
      title="添加按钮"
      width="600px"
      @close="btnClose">
      <el-form ref="btnForm" label-width="120px" :model="btnForm" :rules="btnFormRules">
        <el-form-item label="按钮图片" prop="image">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: btnForm.image.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="btnForm.image"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="跳转页面" prop="url">
          <el-input v-model="btnForm.url" placeholder="请输入跳转页面" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="btnClose">取 消</el-button>
        <el-button type="primary" @click="btnSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createArticle, updateArticle } from '@/api/display'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'ArticleEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      form: {
        articleId: '',
        title: '',
        text: '',
        buttonList:[],
        order: 1,
      },
      btnForm:{
        image:[],
        url:''
      },
      rules: {

      },
      btnFormRules:{
        url:[{ required: true, trigger: 'blur', message: '请输入跳转页面' }]
      },
      dialogFormVisible: false,
      btnFormVisible:false
    }
  },
  methods: {
    inputChange(value) {
      this.form.text = value
    },
    addBtn() {
      this.btnFormVisible = true
    },
    btnSave() {
      this.$refs['btnForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.btnForm)
          // form.url = 'form/index/index?sheetId=' + form.url
          this.form.buttonList.push(form)
          this.btnClose()
        } else {
          return false
        }
      })
    },
    btnDelete(index) {
      this.form.buttonList.splice(index,1)
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改文章'
        this.form = Object.assign(this.form, row.basic)
        this.form.articleId = row.articleId
        this.form.title = row.title
      } else {
        this.title = '新增文章'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    image_remove(file, fileList) {
      this.btnForm.image = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.btnForm.image.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    btnClose() {
      this.$refs['btnForm'].resetFields()
      this.btnForm = this.$options.data().btnForm
      this.btnFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const articleId = this.form.articleId
          this.$baseConfirm(
            `你确定要${articleId ? '修改' : '新增'}文章吗`,
            null,
            async () => {
              articleId
                ? await updateArticle(this.form)
                : await createArticle(this.form)
              this.$baseMessage(
                `${articleId ? '修改' : '新增'}横幅成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
